<template>
  <div v-html="content_section">
      <!--section class="impress_area p_120 bg-parallax"><div class="container"><div class="impress_inner text-center"><h2>Está a procura de um projeto específico?</h2><p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Doloremque, labore? Architecto adipisci cumque nihil at! Possimus, numquam temporibus harum explicabo mollitia, odio, dolorum deleniti eos perspiciatis error sequi! Explicabo, mollitia.</p> <a class="main_btn" href="/contato">Entre em contato</a></div></div> </section -->
  </div>
</template>

<script>
export default {
    name: 'Contact',
    props: {
      content_section: String,
    },
}
</script>

<style>

</style>